// extracted by mini-css-extract-plugin
module.exports = {"title":"BasicInfo_title__Nu1rD","upload":"BasicInfo_upload__UE_9Y","verticals":"BasicInfo_verticals__KAjrE","selected":"BasicInfo_selected__1TyhS","next":"BasicInfo_next__p9yZb"};